import BottomButtons from "../../button/BottomButtons";
import Logo from "../../button/Logo";
import TopButtons from "../../button/TopButtons";

function Mainlogos() {
  return (
    <div style={{ height: "0px" }}>
      <Logo />
      <TopButtons />
      <BottomButtons />
    </div>
  );
}

export default Mainlogos;
